// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preview-section[data-v-e5c764e2]{padding:8px}.preview-section__title[data-v-e5c764e2]{font-size:16px;font-weight:700;line-height:22px;letter-spacing:0;text-align:left}", ""]);
// Exports
module.exports = exports;
